<kui-option-panel #settingsMenu
    [options]="options"
    [isMobile]="isMobile"
    (selectionChanged)="optionChanged($event)"></kui-option-panel>

<key-layout-view page="status"
    [header]="header"
    [show]="show">
    <div class="flex-1 d-flex">

        <key-filter-panel *ngIf="!isMobile && state.showFilter"
            class="border-right"
            [filters]="filterPanelConfig"
            [width]="filterWidth + 'px'">
        </key-filter-panel>


        <kui-side-panel *ngIf="isMobile && state.showFilter"
            [absolute]="true"
            [width]="'75%'"
            (onSwipe)="toggleFilters()">
            <kui-side-panel-item>

                <key-filter-panel class="border-right"
                    [filters]="filterPanelConfig"
                    [width]="'100%'">
                </key-filter-panel>

            </kui-side-panel-item>
        </kui-side-panel>

        <div class="d-flex flex-1 flex-column">

            <kui-input-group *ngIf="searchIsOpen">
                <kui-select
                    [options]="searchTargetOptions"
                    (change)="changeSelection($event)"
                    class="search-target"
                ></kui-select>

                <input kui-input
                    type="text"
                    #searchBar
                    [placeholder]="'STATUS.LIST.SEARCH_ASSETS' | translate"
                    [(ngModel)]="searchValue">

                <button kui-button
                    kui-input-group-addon
                    color="secondary">
                    <kui-icon *ngIf="listLoaded"
                        name="paper-plane"
                        (click)="submitSearch(searchValue)"></kui-icon>
                    <kui-loader *ngIf="!listLoaded"
                        size="small"></kui-loader>
                </button>

                <button kui-button
                    kui-input-group-addon
                    color="danger"
                    (click)="toggleSearchbar()">
                    <kui-icon name="times"></kui-icon>
                </button>
            </kui-input-group>

            <kui-content-header *ngIf="(filter | isFiltering) || (searchValue && !searchIsOpen)"
                [custom]="true"
                [sub]="true"
                class="filters w-100">
                <div class="p-3 d-flex flex-1">
                    <kui-icon name="filter"
                        class="mt-1"
                        size="sm"></kui-icon>
                    <div class="flex-1 px-3">
                        <span *ngIf="searchValue && !searchIsOpen"><strong>{{searchTargetSelected?.value || 'SHARED.SEARCH' | translate}}</strong>: {{ searchValue }}</span>
                        <div *ngFor="let filterItem of filter | filterDisplay; let i = index">
                            <strong>{{ filterItem.type }}:</strong>
                            <ul class="mb-1">
                                <li *ngFor="let name of filterItem.names">{{name}}</li>
                            </ul>
                        </div>
                    </div>
                    <kui-loader *ngIf="!listLoaded"
                        size="small"
                        class="ml-auto"></kui-loader>
                    <kui-icon kui-btn
                        kui-action
                        *ngIf="listLoaded"
                        [title]="'STATUS.LIST.CLEAR_FILTER' | translate"
                        name="times"
                        (click)="clearFilters() && clearSearch()"
                        class="ml-auto"></kui-icon>
                </div>
            </kui-content-header>

            <kui-alert type="info"
                *ngIf="assetListing.length === 0 && listLoaded"
                class="key-alert-wrapper">
                <kui-icon name="lightbulb"
                    size="sm"></kui-icon>
                <span>{{ 'STATUS.LIST.NO_ASSETS' | translate }}</span>
            </kui-alert>

            <div key-content-container
                [scroll]="true"
                (click)="sidebarIsOpen = false"
                #contentContainer>

                <div class="loading-overlay d-flex flex-stretch justify-content-center align-items-center"
                    *ngIf="!listLoaded && !errorMessage">
                    <kui-loader>
                    </kui-loader>
                </div>

                <kui-alert-panel [message]="errorMessage"></kui-alert-panel>

                <div *ngIf="!errorMessage && layout === 'table' && listLoaded"
                    class="table-container"
                    [style.width]="tableWidth">
                    <kui-table *ngIf="!!assetListing.length"
                        #table
                        [rows]="assetListing"
                        [selection]="true"
                        [sort]="true"
                        [sortField]="sortField"
                        [sortOrder]="sortOrder"
                        [resize]="true"
                        [height]="tableHeight"
                        [cols]="columns"
                        (onCollResize)="onColumnsResize($event)"
                        (onCollReoreder)="onColumnsReorder($event)"
                        (onRowSelect)="selectAsset($event)"
                        (onSort)="sortingChanged.emit($event)"></kui-table>
                </div>

                <ng-container *ngIf="!errorMessage && layout === 'list' && listLoaded">
                    <key-listing *ngFor="let asset of assetListing"
                        [hover]="true"
                        [color]="asset.iconColor"
                        [active]="activeAssetId === asset.id"
                        [disabled]="!asset?.telemetry?.location"
                        (click)="selectAsset(asset)">
                        <key-listing-avatar>
                            <div class="position-relative">
                                <div [innerHTML]="sanitize(asset.icon)"></div>
                                <div class="my-1 text-dark small"
                                    *ngIf="filterService?.point && asset.distance !== undefined">
                                    {{ asset.distance | units: 'distance' }}
                                </div>
                                <div class="lock-icon"
                                    *ngIf="asset.hasGeoLock"
                                    [class.warning]="asset.hasGeoLock === 'warning'">
                                    <kui-icon [name]="'lock'"
                                        size="sm"></kui-icon>
                                </div>
                            </div>
                        </key-listing-avatar>
                        <key-listing-stat *ngIf="asset.last_update"
                            class="pr-2">
                            <span [class.text-danger]="shouldHighlightAssetDate(asset)"
                                [innerHtml]="asset.last_update.display"></span>
                        </key-listing-stat>
                        <key-listing-title class="mb-1">
                            {{asset | assetDisplayName: displayNameField}}
                            <div class="small muted-less" *ngIf="asset.fields | isValidCustomField: displayNameField">
                                {{asset.name}}
                            </div>
                        </key-listing-title>
                        <key-listing-description *ngIf="asset | getKey: 'telemetry.location'">
                            {{asset.telemetry.location.address}}
                        </key-listing-description>
                        <div class="float-right pr-2 d-flex align-items-center">
                            <div *ngFor="let icon of asset.icons">
                                <kui-icon *ngIf="icon"
                                    class="muted"
                                    [name]="icon.icon"
                                    [title]="icon.name">
                                </kui-icon>
                            </div>
                            <kui-toggle
                                *ngIf="!this.isMobile && asset?.telemetry?.location"
                                size="sm"
                                class="pl-2"
                                [disabled]="activeAssetId === asset.id"
                                [checked]="assetMapVisibility | mapGet: asset.id"
                                (click)="$event.stopPropagation()"
                                (onChange)="setAssetMapVisibility($event, asset)">
                            </kui-toggle>
                        </div>
                    </key-listing>

                </ng-container>
            </div>
        </div>
    </div>
    <kui-content-header *ngIf="count"
        [custom]="true"
        [sub]="true"
        class="w-100">

        <kui-paginate *ngIf="pageCount > 1"
            class="ml-3"
            [page]="page"
            [total]="count"
            [perPage]="filterService.limit"
            [collapse]="true"
            (pageChanged)="onPageChanged($event)"></kui-paginate>

        <div class="ml-auto pr-3">
            {{ count === 1 ? ('STATUS.LIST.ONE_ITEM' | translate) : ('STATUS.LIST.TOTAL_ITEMS' | translate: { total: count }) }}
        </div>
    </kui-content-header>
</key-layout-view>